import { Grid, xcss } from '@atlaskit/primitives';
import React from 'react';

const fillResponsiveGridStyles = xcss({
	gridTemplateColumns: 'repeat(auto-fit, minmax(252px, 1fr))',
	gap: 'space.200',
	// Cancel out ul styles
	listStyleType: 'none',
	paddingInlineStart: 'space.0',
	marginBlockStart: 'space.0',
});

const responsiveGridStyles = xcss({
	gridTemplateColumns: 'repeat(auto-fill, minmax(252px, 1fr))',
	gap: 'space.200',
	// Cancel out ul styles
	listStyleType: 'none',
	paddingInlineStart: 'space.0',
	marginBlockStart: 'space.0',
});

interface Props {
	children: React.ReactNode;
	fillAvailableSpace?: boolean;
}

export const AppsGrid = ({ children, fillAvailableSpace = false }: Props) => (
	<Grid xcss={fillAvailableSpace ? fillResponsiveGridStyles : responsiveGridStyles} as="ul">
		{children}
	</Grid>
);
